import { FC } from 'react';
import { useMount } from 'react-use';

import { IonAvatar } from '@ionic/react';
import { useContextSelector } from 'use-context-selector';

import { CardContext } from '../Card.context';

import styles from './CardAvatar.module.scss';

interface CardAvatarProps {
  src: string;
  dimantion?: number;
}

export const CardAvatar: FC<CardAvatarProps> = ({ src, dimantion = 64 }) => {
  const setState = useContextSelector(CardContext, ({ setState }) => setState);

  useMount(() => {
    setState((prev) => ({ ...prev, avatar: dimantion }));
  });

  return (
    <IonAvatar
      className={styles.root}
      style={{ width: dimantion, height: dimantion }}
    >
      <img src={src} alt="" />
    </IonAvatar>
  );
};
